/* eslint-disable max-len */
// src/utils/gtm.ts
import TagManager from 'react-gtm-module';

const GTM_ID = process.env.REACT_APP_GTM_ID || '';

type GTMEventParams = {
  [key: string]: any;
};

export const initializeAffiliateGTM = (affiliateGTM: string) => {
  const tagManagerArgs = {
    gtmId: affiliateGTM,
    dataLayer: {
      userRole: 'visitor'
    }
  };

  try {
    TagManager.initialize(tagManagerArgs);
  } catch (e) {
    console.error('Error initializing GTM', e);
  }
};

// Initialize GTM with TypeScript
export const initializeGTM = () => {
  const tagManagerArgs = {
    gtmId: GTM_ID,
    dataLayer: {
      userRole: 'visitor'
    }
  };

  try {
    TagManager.initialize(tagManagerArgs);
  } catch (e) {
    console.error('Error initializing GTM', e);
  }
};

export const trackEvent = (eventName: string, eventParams: GTMEventParams = {}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...eventParams
    }
  });
};

interface UserData {
    email: string;
    first_name: string;
    last_name: string;
    document_number: string;
    phone: string;
}

interface EcommerceItem {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
}

interface BaseEcommerceParams {
  currency?: string;
  value?: number;
  items?: EcommerceItem[];
}

interface ShippingInfo extends BaseEcommerceParams {
    shipping_address?: {
      city: string;
      street: string;
      number: string;
      neighborhood: string;
      state: string;
      postal_code: string;
      complement?: string;
    }
  }

interface PurchaseParams extends BaseEcommerceParams {
  transaction_id: string;
}

interface PaymentInfo extends BaseEcommerceParams {
  payment_type: string;
  value?: number;
  currency: string;
  items?: EcommerceItem[];
  installments?: number;
}

export const ecommerceEvents = {
  beginCheckout: (params: any = {}) => {
    trackEvent('begin_checkout', params);
  },

  viewPromotion: (params: any = {}) => {
    trackEvent('view_promotion', params);
  },

  selectPromotion: (params: any = {}) => {
    trackEvent('select_promotion', params);
  },

  beginCheckoutDados: (params: any = {}) => {
    trackEvent('begin_checkout_dados', params);
  },

  signUp: (params: { method?: string, user_data?: UserData, client_domain?: string } = {}) => {
    trackEvent('sign_up', params);
  },

  addShippingInfo: (params: ShippingInfo = {}) => {
    trackEvent('add_shipping_info', params);
  },

  addPaymentInfo: (params: PaymentInfo) => {
    trackEvent('add_payment_info', params);
  },

  purchase: (params: PurchaseParams) => {
    trackEvent('purchase', params);
  }
};